<template>
  <SectionContainer
    v-if="hasLives"
    variant="gray"
  >
    <SectionHeader>
      <template v-slot:title>
        <b>Não perca nossas lives <span class="hl">gratuitas</span></b>
      </template>

      <template v-slot:subtitle>
        Dicas preciosas por experts das áreas
      </template>
    </SectionHeader>

    <HorizontalCarousel :items="livesScheduled">
      <template v-slot="{ item }">
        <LiveScheduleThumbBox :live="item" />
      </template>
    </HorizontalCarousel>
  </SectionContainer>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SectionContainer from '@/components/layout/SectionContainer'
  import LiveScheduleThumbBox from '@/components/course/LiveScheduleThumbBox'
  import SectionHeader from '@/components/layout/SectionHeader'
  import HorizontalCarousel from '@/components/carousel/HorizontalCarousel'

  export default {
    components: {
      LiveScheduleThumbBox,
      SectionContainer,
      SectionHeader,
      HorizontalCarousel,
    },

    mounted () {
      this.fetchLivesScheduled()
    },

    computed: {
      ...mapGetters('live', ['livesScheduled']),

      hasLives () {
        return !!this.livesScheduled.length
      }
    },

    methods: {
      async fetchLivesScheduled () {
        await this.$store.dispatch('live/getLivesScheduled')
      }
    }
  }
</script>